/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useEffect, useRef } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'
import { ChevronDownIcon, PlusSmIcon } from '@heroicons/react/solid'
import LoadingBar from 'react-top-loading-bar'
import slugify from 'slugify';

import SimplifiedHeader from '../components/SimplifiedHeader'
import StickyHeader from '../components/StickyHeader'
import Footer from '../components/Footer'
import DealService from '../services/DealService'
import useTitle from '../hooks/useTitle'
import ReadMore from "../components/ReadMore"

import { DealProvider, DealContext, useDeal } from '../providers/DealProvider';

import HeroBanner from './components/HeroBanner'
import DealFilter from './components/DealFilter'
import DealGrid from './components/DealGrid'
import MarketPlaceSearch from '../components/MarketplaceSearch'
import PlacholderImg from "../../images/placeholder.png";
import { UserProvider, useUser } from '../providers/UserProvider';
import NoResultsImage from "../../images/search-no-results-image.png";

const profile = ['Your Profile', 'Settings', 'Sign out']

const navigation = {}
const breadcrumbs = [{ id: 1, name: 'Men', href: '#' }]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Seperator = () => {
  return (
    <div className="w-full border-t border-gray-300" />
  )
}

const CodeCopy = (props) => {
  const [copied, setCopied] = useState("Copy");
  let deal = props.deal;
  const copyCodeToClipboard = (evt) => {
    let code = props.deal.redemption_code;
    navigator.clipboard.writeText(code).then(() => {
      setCopied('Copied');

    }, (err) => {
      console.error("Failed to copy Text.");
      setCopied('Error');
    });

  }

  useEffect(() => {
    setCopied("Copy");
  }, [props.deal.redemption_code]);

  return (
    <div id="clipboard_btn" className="cursor-pointer inline-block text-body-2 bg-grey-codeCopy py-2 px-4 rounded-full" onClick={copyCodeToClipboard}>
      <div className="">
        {props.deal.redemption_code}
        <span className="bg-blue-700 text-white rounded-full ml-3 px-2.5 py-0.5 inline">
          {copied}
        </span>
      </div>
    </div>
  )
}

const LinkRedeem = (props) => {
  const deal = props.deal;
  let currentStyle = 'inline-flex w-full items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-body-1-md rounded-full text-black bg-white hover:text-white hover:bg-blue-700';

  const [user, userDispatch] = useUser();

  return (
    <>
      {user.loggedIn &&
        <>
          <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3>
          <p><span className="font-primary text-body-2 p-2 rounded-[3px] bg-convoy-deal-type">Link</span></p>
          <p className="text-grey-lighter text-body-2">
            <ReadMore>
              {deal.desc}
            </ReadMore>
          </p>

          <Seperator />

          <div className="mb-4">
            <a id="redeem_btn" target="_blank" href={deal.redemption_url} className={currentStyle}>Redeem</a>
          </div>
        </>
      }

      {!user.loggedIn &&
        <>
          <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3>
          <p><span className="font-primary text-body-2 p-2 bg-convoy-deal-type">Link</span></p>
          <p className="blur-sm text-grey-lighter text-body-2">
            <div className="transition ease-in-out delay-150">
              <p>Get a 30-day free trial when you sign up through The Convoy using the link provided.</p>
              <p>Offer Details:  Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing ...</p>
              <p className="mt-2 underline">
                Read More
              </p>
            </div>
          </p>

          <Seperator />

          <div className="mb-4 space-y-4">
            <p className="font-primary text-body-2 text-center">Get this and 150+ offers when you sign up through The Convoy.</p>
            <a href="/register" className='inline-flex w-full items-center justify-center px-14 py-4 font-cta-label text-white text-body-1-md rounded-full bg-blue-500 hover:bg-blue-400'>Sign Up</a>
          </div>
        </>
      }
    </>
  )
}

const CodeRedeem = (props) => {
  const deal = props.deal;
  let currentStyle = 'inline-flex w-full items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-body-1-md rounded-full text-black bg-white hover:text-white hover:bg-blue-700';

  const [user, userDispatch] = useUser();

  return (
    <>
      {user.loggedIn &&
        <>
          {/* <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3> */}
          <p><span className="font-primary text-body-2 p-2 rounded-[3px] bg-convoy-codeCopy">Code</span></p>
          <p className="text-grey-lighter text-body-2">
            <ReadMore>
              {deal.desc}
            </ReadMore>
          </p>
          <div className="">
            <CodeCopy deal={deal} />
          </div>

          {/* <Seperator />

          <div className="mb-4">
            <a id="redeem_btn" target="_blank" href={deal.redemption_url} className={currentStyle}>Redeem</a>
          </div> */}
        </>
      }

      {!user.loggedIn &&
        <>
          <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3>
          <p><span className="font-primary text-body-2 p-2 bg-convoy-codeCopy">Code</span></p>
          <p className="blur-sm text-grey-lighter text-body-2">
            <div className="transition ease-in-out delay-150">
              <p>Get a 30-day free trial when you sign up through The Convoy using the link provided.</p>
              <p>Offer Details:  Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing ...</p>
              <p className="mt-2 underline">
                Read More
              </p>
            </div>
          </p>
          <div className="blur-sm">
            <span className="text-body-2 bg-grey-codeCopy py-2 px-4 rounded-full w-[120px] flex flex-cols justify-center">
              <div className="">CODE</div>
              <div className="bg-blue-700 text-white rounded-full ml-4 px-2">
                Copy
              </div>
            </span>
          </div>

          <Seperator />

          <div className="mb-4 space-y-4">
            <p className="font-primary text-body-2 text-center">Get this and 150+ offers when you sign up through The Convoy.</p>
            <a href="/register" className='inline-flex w-full items-center justify-center px-14 py-4 font-cta-label text-white text-body-1-md rounded-full bg-blue-500 hover:bg-blue-400'>Sign Up</a>
          </div>
        </>
      }
    </>
  )
}

function TemplatePage() {
  const loadingBarRef = useRef(null);
  const [relatedDeals, setRelatedDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deal, setDeal] = useState(null);

  const { dealId, catSlug } = useParams();

  useTitle("Browse Savings | The Convoy | Save on everyday business expenses.");

  useEffect(() => {
    const fetchDeal = async () => {
      loadingBarRef.current.continuousStart();
      // Add error handling to activeDeal is not null.
      const response = await DealService.getDeal(dealId);
      
      let payload = response.data.data;
      let errors = response.data.errors;

      if (errors) {
        setLoading(false);
        return;
      }

      let idx = Math.floor(Math.random() * payload.deals.length - 4);
      let deal = payload.deal;

      if (deal && deal.category) {
        deal.category = deal.category.map((category) => {
          let display = payload.dealCategories.filter((cat) => {
            return cat.key == category;
          });
          return display.pop();
        }).filter(x => x);

        console.log(deal.similarDeals);
        setRelatedDeals(deal.similarDeals);
      }

      setDeal(deal);
      loadingBarRef.current.complete();
      setLoading(false);
      // dispatch({ type: "quickview/open", payload: { deal: deal, relatedDeals: payload.deals.slice(idx, idx + 4) } });
    };

    fetchDeal()
      .catch(error => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="bg-white">
      <StickyHeader />
      <LoadingBar color='#0173FF' ref={loadingBarRef} />
      <DealProvider>
        <main className="mx-auto container">
          {/* {loading && <>Loading...</>} */}
          {!deal && !loading && <div className="col-span-3" style={{
            // height: '476px',
            borderRadius: '3px',
            backgroundColor: 'rgba(229, 241, 255, 1)',
            border: '1px solid rgba(237, 237, 237, 1)',
          }}>
            <h2 className="text-center mt-20 mb-2 text-headline-2 font-secondary">Oops!</h2>
            <p style={{ color: '#111827' }} className="text-center text-body-1-md font-primary mb-12">Looks like that deal is no longer in use, but check out the <Link className="underline text-convoy-light-blue" to={'/marketplace'}>Marketplace</Link> for some others you might like.</p>
            <img
              className="h-auto w-auto object-cover mx-auto mb-14"
              src={NoResultsImage}
              alt="No results"
            />
          </div>}
          {deal && <div className="xl:flex xl:flex-row xl:justify-between">
            <div className="xl:w-4/12 pt-6 xl:pr-4">
              <div className='flex flex-col items-center'>
                <img 
                  src={deal.vendor.image || ""}
                  alt={deal.imageAlt} 
                  className="mb-2"
                />
                <p className='font-primary text-body-1 text-grey-section mb-2'>
                  { deal.vendor.name }
                </p>
                <h3 className='font-secondary text-headline-3 text-convoy-section-title font-bold'>{ deal.name }</h3>
                <p className='font-primary text-body-1 text-grey-section mb-2 text-center'>
                  {deal.category.map((cat, idx) => (
                    <span key={idx}>{idx % 2 === 1 ? ' | ' : ''} {cat.name}</span>
                  ))}
                </p>
                <p className='font-primary text-body-1 text-grey-section mb-2 text-center'>
                  { deal.shortDesc }
                </p>
                <div className="flex flex-row items-center justify-center bg-white w-full py-4 text-center border-2 border-convoy-aqua rounded-2xl group-hover:outline-card mb-4">
                  <div className="font-secondary font-weight-700 text-convoy-aqua text-headline-3 uppercase mr-2">{ deal.averageSavings }</div>
                  <div className="font-secondary font-weight-700 text-overline uppercase">Average Savings</div>
                </div>
                <div className="section-border mb-4 w-full"></div>
                <a 
                  id="redeem_btn" 
                  target="_blank" 
                  href={deal.redemption_url}
                  className="inline-flex w-full items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-body-1-md rounded-full text-white bg-blue-700"
                >Redeem</a>
              </div>
            </div>
            <div className="xl:pb-24 xl:w-8/12 pt-6">
              {/* {posts.map((post, idx) => (
                <div key={idx} className="section-border mb-4">
                  <p className="text-sm text-gray-500">
                    <time dateTime={post.datetime}>{post.date}</time>
                  </p>
                  <a href="#" className="block">
                    <h3 className="font-secondary text-headline-3 text-convoy-section-title font-bold">{post.title}</h3>
                    <p className="my-4 font-primary text-body-1 text-grey-section">{post.description}</p>
                  </a>
                  <div className="pb-4">
                    <a href={post.href} className="font-primary text-body-1 text-grey-section underline">
                      Read More
                    </a>
                  </div>
                </div>
              ))} */}
              <div className="section-border mb-4">
                <a href="#" className="block">
                  <h3 className="font-secondary text-headline-3 text-convoy-section-title font-bold">
                    How to Redeem
                  </h3>
                  <div className="my-4 space-y-4">
                    {/* Link Redemption  */}
                    {(deal.redemption_type == 'Link') &&
                      <LinkRedeem deal={deal} />
                    }

                    {/* Code Redemption  */}
                    {(deal.redemption_type == 'Code') &&
                      <CodeRedeem deal={deal} />
                    }
                  </div>
                </a>
                <div className="pb-4">
                  {/* <a href={''} className="font-primary text-body-1 text-grey-section underline">
                    Read More
                  </a> */}
                </div>
              </div>
              <div className="section-border mb-4">
                
                <h3 className="font-secondary text-headline-3 text-convoy-section-title font-bold">About the Company</h3>
                <p className="my-4 font-primary text-body-1 text-grey-section">
                  <ReadMore>
                    {deal.vendor.desc}
                  </ReadMore>
                </p>
                
                {/* <div className="pb-4">
                  <a href={post.href} className="font-primary text-body-1 text-grey-section underline">
                    Read More
                  </a>
                </div> */}
              </div>
              <div className="section-border mb-4">
                
                <h3 className="font-secondary text-headline-3 text-convoy-section-title font-bold">Terms &amp; Conditions</h3>
                <p className="my-4 font-primary text-body-1 text-grey-section">
                  {deal.terms}
                </p>
                
                {/* <div className="pb-4">
                  <a href={post.href} className="font-primary text-body-1 text-grey-section underline">
                    Read More
                  </a>
                </div> */}
              </div>
              <h3 className="font-secondary text-headline-3 text-convoy-section-title font-bold mb-4">
                Similar Offers
              </h3>
              {deal && deal.similarDeals.map((deal, idx) => (
              <div key={idx} className='flex flex-row py-4'>
                <div>
                  <img src={deal.vendor.image || ""} alt={deal.vendor.desc} style={{ maxWidth: '60px' }} />
                </div>
                <div className='ml-3'>
                  <a href={`/marketplace/${slugify(deal.vendor.name, { lower: true })}/${slugify(deal.name, { lower: true })}/${deal.id}`}>
                    <h3 className='text-headline-4 font-secondary font-bold text-convoy-section-title-smaller'>
                        {deal.name}
                    </h3>
                  </a>
                  <p className='font-primary text-body-1 text-grey-footer'>
                      {deal.shortDesc}
                  </p>
                </div>
              </div>))}
            </div>
          </div>}
        </main>
      </DealProvider>

      <div className="container mx-auto">
        <Footer />
      </div>
    </div>
  )
}

export default TemplatePage;
